import general from "../../../../../general";
import Dialog from "../../../../../lib/Dialog";

// ── 操作列表定义（纯数据）────────────────────────────────────────────────────
const ACTIONS = {
  out:            [{ text: "撤回", key: "recall" }, { text: "删除", key: "delete" }, { text: "复制", key: "copy" }],
  in:             [{ text: "回复", key: "reply" },  { text: "删除", key: "delete" }, { text: "复制", key: "copy" }],
  appointIn:      [{ text: "回复", key: "reply" },  { text: "删除", key: "delete" }, { text: "复制", key: "copy" }, { text: "撤回", key: "appoint" }],
  outMedia:       [{ text: "回复", key: "reply" },  { text: "保存", key: "save-media" }, { text: "撤回", key: "recall" }, { text: "删除", key: "delete" }],
  inMedia:        [{ text: "回复", key: "reply" },  { text: "保存", key: "save-media" }, { text: "删除", key: "delete" }],
  appointInMedia: [{ text: "回复", key: "reply" },  { text: "保存", key: "save-media" }, { text: "删除", key: "delete" }, { text: "撤回", key: "appoint" }],
  outCustom:      [{ text: "撤回", key: "recall" }, { text: "删除", key: "delete" }],
  outRedPacket:   [{ text: "回复", key: "reply" },  { text: "删除", key: "delete" }],
  inCustom:       [{ text: "回复", key: "reply" },  { text: "删除", key: "delete" }],
  appointInCustom:[{ text: "回复", key: "reply" },  { text: "删除", key: "delete" }, { text: "撤回", key: "appoint" }],
};

export function getMessageActions(msg, { isAppointed }) {
  const isRecent = Date.now() - msg.time < 120000;
  const isMine = msg.flow === "out";
  if (msg.type === "image" || msg.type === "video") {
    if (isRecent && isMine) return ACTIONS.outMedia;
    return isAppointed ? ACTIONS.appointInMedia : ACTIONS.inMedia;
  }
  if (msg.type === "custom") {
    const isRedPacket = msg.subType === 6 || msg.subType === 7;
    if (isRedPacket) return isMine ? ACTIONS.outRedPacket : ACTIONS.inCustom;
    if (isRecent && isMine) return ACTIONS.outCustom;
    return isAppointed ? ACTIONS.appointInCustom : ACTIONS.inCustom;
  }
  if (isRecent && isMine) return ACTIONS.out;
  return isAppointed ? ACTIONS.appointIn : ACTIONS.in;
}

export function createMessageActionHandler({ store, sessionId, tid, setReplyMsg }) {
  return (key, msg) => {
    if (key === "recall") {
      store.msgStore.reCallMsgActive(msg);
    } else if (key === "delete") {
      store.msgStore.deleteMsgActive([msg]);
    } else if (key === "copy") {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(msg.body || "").catch(() => {});
      } else {
        const ta = document.createElement("textarea");
        ta.value = msg.body || "";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
      }
      Dialog.info("已复制到剪贴板");
    } else if (key === "reply") {
      store.msgStore.replyMsgActive(msg);
      setReplyMsg(msg);
      // 只显示回复条，不自动聚焦/弹键盘，不改变列表位置，由用户自行点击输入框
    } else if (key === "appoint") {
      general.axios.post("/base/yunxin/frontRecallMsg", {
        tid,
        msgid: msg.idServer,
        msg_from_account: msg.from,
        msg_timestamp: msg.time,
      });
    } else if (key === "save-media") {
      const url = msg.file?.url || msg.attach?.url || "";
      if (!url) return;
      const isVideo = msg.type === "video";
      const rawName = url.split("?")[0].split("/").pop() || (isVideo ? "video.mp4" : "image.jpg");
      const fileName = rawName.includes(".") ? rawName : rawName + (isVideo ? ".mp4" : ".jpg");
      Dialog.info("正在保存，请稍候…");
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error("network");
          return res.blob();
        })
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
          Dialog.info(isVideo ? "视频已保存到下载" : "图片已保存到下载");
        })
        .catch(() => {
          // fetch 失败（如跨域限制）降级直接打开
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    }
  };
}
